import { api } from '../client';
import type { User } from '../types';

interface ListParams {
  /** apenas admin/manager pode usar */
  all?: boolean;
  /** filtra usuários gerenciados por outro usuário */
  userId?: number;
}

export const usersApi = {
  list: (params?: ListParams) => api.get<User[]>('/users', { query: params }),
  create: (user: Partial<User>) => api.post<User>('/users', { body: user }),
  update: (id: number, user: User) => api.put<User>(`/users/${id}`, { body: user }),
  delete: (id: number) => api.delete<void>(`/users/${id}`),
};
